import type { InvestmentsFeatures } from '../types';

export const features: InvestmentsFeatures = {
    enabled: true,
    _description: 'Enables investments as a whole for the user. It is disabled by default.',
    digiVV: {
        enabled: false,
        _description:
            'Enables the functionality of digiVV invest manager for the user. It is disabled by default.',
    },
    export: {
        enabled: true,
        _description:
            'Enables the export functionality for the user. It allows the user to export reports in different formats. It is disabled by default.',
    },
    externalPlatform: {
        enabled: false,
        _description:
            'Enables the functionality of using an external trading system for the user. It is disabled by default.',
    },
    gainloss: {
        enabled: false,
        _description:
            'Enables the functionality to display the gain loss link in the securities overview page. It is disabled by default.',
    },
    watchlist: {
        enabled: false,
    },
    priceAlerts: {
        enabled: false,
    },
    marketDataPortal: {
        enabled: false,
    },
    advertisement: {
        enabled: false,
    },
    appropriatenessTest: {
        enabled: false,
    },
    statements: {
        enabled: true,
    },
    statementsDownloadCurrentLanguage: {
        enabled: true,
    },
    buyLinkTarget: {
        enabled: false,
    },
    pip: {
        enabled: false,
    },
    pipAdvisory: {
        enabled: false,
    },
    pipPriceMod: {
        enabled: false,
    },
    standaloneSecuritiesAccountOpeningFlow: {
        enabled: false,
        _description: 'Enables the standalone portfolio creation page',
    },
    investmentPlans: {
        enabled: false,
    },
    orders: {
        enabled: true,
        _description:
            'Enables the securities orders functionality for the user. It is disabled by default.',
    },
    overviewPerformance: {
        enabled: false,
        _description:
            'Enables the performance functionality for the user. It allows the user to see the performance section in the overview page. It is disabled by default.',
    },
    privateBanking: {
        enabled: false,
        _description:
            'Enables the private banking section for the user where he can see all his reports. It is disabled by default.',
    },
    profile: {
        enabled: false,
        _description:
            'Enables the securities profile functionality for the user. It allows the user to activate trading and update his knowledge and experience about trading. It is disabled by default.',
    },
    regularOrders: {
        enabled: false,
        _description:
            'Enables the regular investments functionality for the user. It allows the user to access the list of regular investments and manage the orders. It is disabled by default.',
    },
    sfondsplan: {
        enabled: false,
        _description:
            'Enables the S Fonds Plan/Investment Plans functionality for the user. It allows the user to open a new investment plan and manage their existing ones. It is disabled by default.',
    },
    trading: {
        enabled: true,
        _description:
            'Enables the trading functionality for the user. It allows the user to trade products using the order form. It is disabled by default.',
    },
    junior: {
        enabled: true,
    },
    fundamentalsData: {
        enabled: false,
    },
    accDetailV2: {
        enabled: false,
    },
    changePrice: {
        enabled: false,
        _description: 'Enables the portfolio model migration card on portfolio settings.',
    },
};
